var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73801 10.3C9.53936 10.1132 9.22965 10.1132 9.03101 10.3L0.768007 18.561C0.297762 19.0287 0.0338669 19.6648 0.0350073 20.328C0.0687115 21.6945 1.1685 22.7943 2.53501 22.828C3.19692 22.8306 3.8324 22.5685 4.30001 22.1L12.563 13.837C12.7582 13.6418 12.7582 13.3253 12.563 13.13L9.73801 10.3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.525 9.23697L22.465 8.17597C22.0745 7.78559 21.4415 7.78559 21.051 8.17597C20.6557 8.55465 20.0323 8.55465 19.637 8.17597C19.3543 7.89416 19.2662 7.4712 19.413 7.09997C19.6273 6.5473 19.496 5.92026 19.078 5.49997C17.646 4.06197 17.071 3.48497 16.785 3.25397H16.792C14.0126 0.662066 9.76319 0.46974 6.761 2.79997C6.40611 3.06016 6.26453 3.52272 6.413 3.93697C6.56406 4.34812 6.96226 4.6156 7.4 4.59997C8.79889 4.54028 10.1591 5.06776 11.152 6.05497C11.669 6.57297 11.931 6.97197 11.931 7.24097C11.9277 7.36067 11.8726 7.47305 11.78 7.54897L10.798 8.52997C10.6028 8.72522 10.6028 9.04172 10.798 9.23697L13.626 12.065C13.8212 12.2602 14.1377 12.2602 14.333 12.065L15.394 11.004C15.7891 10.6259 16.4119 10.6259 16.807 11.004C17.1974 11.3945 17.1974 12.0275 16.807 12.418C16.4166 12.8085 16.4166 13.4415 16.807 13.832L17.868 14.9C18.4537 15.4855 19.4032 15.4855 19.989 14.9L23.525 11.364C24.1106 10.7782 24.1106 9.82872 23.525 9.24297V9.23697Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.531b0736.svg";
export { ForwardRef as ReactComponent };